module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter Two")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("“Y")])]), _vm._v("ou’re not eating.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mason looked across the table at Lily, his words rising above the din of the few diners in the restaurant they’d found just around the corner from Jim’s office.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When she didn’t respond, he added, “Lily, at least drink some of your tea. You don’t look too hot.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t feel too hot,” she echoed, grabbing her iced tea to take a long, nervous gulp. Finally she looked up, right into his eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And took his breath away. She looked so lost, so hurt, so…alone, sitting there in the bright sunshine filtering through the window beside them.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Maybe I should just take you home,” he said, concern evident in his words. “I just thought if I got some food in you—”")])]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t need food,” she replied, her patience with this whole absurd situation clearly gone. “I— I just can’t believe Daniel would…expect you to…” She couldn’t even say the words.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mason shook his head, then reached across the table to take her hand in his. He could feel the erratic pulse beating against her tiny wrist. “Lily, just forget about it. Look, we both know Daniel wasn’t himself toward the end. He didn’t know what he was doing. He didn’t realize what he was asking.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He wrote this will long before that, and you know it,” she snapped. Seeing the dark flare of anger in his deep blue-black eyes—eyes that reminded her of her beloved lake and the husband she’d just buried—she lowered her voice and tried again. “I’m sorry, Mason. It’s just that this is so embarrassing. Imagine you and me, getting married. Why, that’s the silliest thing I’ve ever heard.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Daniel didn’t think it was silly,” he reminded her, his ego slightly bruised that she’d find marrying him so incredulous. But, the truth be told, he himself thought the whole idea "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("was")]), _vm._v(" ludicrous. What had Daniel been thinking?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("For starters, Mason lived in Dallas—easily over two hours away—and Lily would never agree to leave the lake. And he could never force her to leave it. She belonged there. But he didn’t. So he couldn’t see him moving back to a place he never wanted to return to in the first place.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v("Logistics aside, this could never work anyway. He ")]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_vm._v("and Lily were as different as Dallas and Caddo Lake. He was a businessman, a confirmed bachelor, a workaholic. Lily was a gentle, kind, hardworking woman with high morals and a good life on the lake she loved. Looking at her now, though, for just an instant, he had to wonder what it would be like to have someone such as Lily as his wife.")])]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("No, that could never be, no matter how many promises he’d made to his dying brother. He certainly hadn’t promised anything like this. Had he?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sighing, he raked a hand through his hair. “Daniel always did take the word of God seriously.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Very,” she replied, her fingers toying with a fat potato chip. Tossing it down beside her uneaten chicken salad sandwich, she let out her own frustrated breath. “He took things so literally. But this, this goes beyond anything else he’s ever done.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re right, of course. It’s just not possible. I mean, it is silly to expect—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Exactly,” she said, some of the tension leaving her face. “We can’t honor his request. We’ll just forget the whole thing.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yeah, that’s probably for the best.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lily sat silent for a minute, then said in a voice so low and trembling that Mason had to strain to hear her, “He always wanted a son, you know.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_vm._v("Mason’s heart went out to her. For as long as he could remember, Lily and Daniel had talked about having children. But sadly, no children were ever born into the Winslow household. “You tried, Lily. ")]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_vm._v("You both tried to have a child. You can’t blame yourself for that not happening.”")])]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I could have made him happy,” she said, tears forming in her eyes. “If I could have given him that one thing—a child—then maybe I wouldn’t be so lonely myself. I’d have something of him, to love and cherish. I couldn’t give him the one thing he really wanted, Mason. And now it’s too late.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("All of Mason’s protective instincts surfaced then. He didn’t think he could bear seeing her cry. Crying made him uncomfortable. After fidgeting in his chair, he finally reached across the table to squeeze her hand. His voice terse and wavering, he said, “It’s not your fault, Lily. Daniel was a very sick man. Sometimes things just aren’t meant to be.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I guess not,” she replied, blinking back tears of regret. “I just wish—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Stop blaming yourself,” he reminded her again, his tone sharp. “You tried to get him to agree to an adoption, remember?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He wanted his own child.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He was a stubborn, proud man, and we both loved him dearly, but my brother had to have things his way. And now this…. Did he actually think we’d agree to this?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m sure he believed we’d honor this request with all our hearts,” Lily said, “just the way he always honored any pledges or promises he made.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mason smiled then, the action bittersweet. “He was a real character, wasn’t he?”")])]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She nodded. “Yes. Which is why I wish I’d had his child. That would have been such a joy.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Any child of yours would be a joy,” Mason said without thinking. “I mean, I’d love it. Hey, I’d be an uncle.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She looked across at him, thinking he was one of the most handsome men she’d ever seen. Both Daniel and Mason Winslow were handsome, though. Two dark-haired brothers, rugged and windblown, not handsome in a pretty, classic sense. But handsome in character, in strength, in life experience. Yet so very different. Daniel had survived on faith and honor, unable and unwilling to ever let anyone down. And Mason—he’d survived on bitterness and distrust, unable and unwilling to make any promises he couldn’t keep.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sniffing back tears, she said, “What about you, Mason? Have you ever wanted children?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He dropped his hand away from her wrist. “Wow, that’s a loaded question.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No, it’s a simple question. You’ve never talked about it much.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And I’d rather not start now.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Thinking she’d touched on a nerve, Lily sat there watching the changing expression on his face. She didn’t miss the trace of pain shooting over his features. “Then we won’t talk about it,” she replied. “And we won’t talk about this request again, ever.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But what about the will?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_vm._v("“What about it? As you said, Daniel was very ")]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_vm._v("sick. I don’t know why he felt it so necessary to include this request in his official will, but I do know that I, for one, don’t expect you to honor it.”")])]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But you would? I mean, if I were willing.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I didn’t say that.” She looked away, out onto the lazy sidewalk shining in the afternoon heat.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But you would honor it, right?” He tugged on her hand. “I know you, Lily. You’re a lot like Daniel in that way. You honor your commitments. Whether you feel comfortable with them or not.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I won’t do anything immoral,” she shot back, her eyes going wide.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I wasn’t suggesting anything immoral. This is more of a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("moral obligation,")]), _vm._v(" after all. Not something we both really want.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No, not at all. And all the more reason to just drop it. I won’t be obligated to you, Mason, and I don’t expect you to be obligated to me. No matter how much Daniel wanted it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He took her hand to guide her up away from the small, round table. “Then it’s settled. We’ll go back to the lake house and go over your bills—see where you stand financially. I can help you sort through that, at least. As for the rest, we’ll just put it out of our minds.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Okay,” she said, feeling better now that they’d talked it through.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Yes, she’d just put it out of her mind. That would be the best thing to do. That was the only thing she could do.")])]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Later, however, her conscience started getting the better of her. Trying to stay busy while Mason sat poring over bills and accounts at the round oak table in her sunny kitchen, Lily ripped at a head of lettuce. She’d invited Mason to stay for supper. Since she had plenty of food from the neighbors and her family, she had thought sharing it would be sensible.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Now she had to wonder if that hadn’t been an excuse. She hadn’t wanted Mason to leave just yet. She didn’t want to be alone.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Silly,")]), _vm._v(" she silently told herself as she sliced fresh cucumbers from her father’s garden and threw in fat chunks of tomatoes from that same garden. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("You’ve never been one to be scared of the dark.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("No, she wasn’t afraid of the night. She loved her nights here on the lake—the sound of wild animals thrashing about in the woods beyond the house, the night birds calling out to each other, the splash of a big fish out near the dock, the sweet scent of magnolias and honeysuckle reaching her through the open windows. Darkness didn’t faze her. But this loneliness that had been creeping in—that was another thing.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_vm._v("It had started right after Daniel had become bedridden. She’d talk to him, cooing and encouraging, but he’d never answer. Sometimes he would open his eyes and they’d follow her around the small bedroom down the hall from the master suite, where ")]), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_vm._v("they’d set up a hospital bed. But he’d never responded or tried to call out to her.")])]), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Maybe it had been the accusation, the disappointment in his eyes, that had brought on this melancholy. Maybe the shroud of certain death hanging over that room had made her less sure of herself and her faith in God or mankind.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In her heart she’d prayed for her husband to find some peace, some relief from his terrible suffering. She knew better than to ask God to spare her husband. She could only ask for God’s will and for His strength to get both Daniel and herself through this, no matter the outcome. But then she’d become selfish and wish with all her might that Daniel would just get up and be his old self. She’d wish for him to be free of the melanoma that had invaded his body and taken over all his organs, free of the pain, the sickness, the weakness that had reduced him from a big, strapping man to a pile of bedridden bones.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("That’s when the loneliness would set in. That’s when the nights would become so quiet, so dark with grief, that she had to wonder if she’d ever see the light of day again. And with the loneliness had come regret—regret that she hadn’t been a better wife to Daniel, regret that she hadn’t forced him to go to the doctor sooner, regret that she hadn’t been able to give him a child.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_vm._v("Now, as she stood looking out over the lake where the setting sun was just beginning to cast out ")]), _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_vm._v("a golden net of rich gloaming, she once again felt the pull of that loneliness and regret. Now she had only her memories to console her. Now Daniel was finally at peace.")])]), _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And she had to wonder, would she ever find her own peace of mind again?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lily closed her eyes for just a moment. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Please, Lord, help me to heal. Help me to find joy again.")]), _vm._v(" She’d let Daniel down in more ways than one. And now she wasn’t even going to honor his final wish. Guilt and regret gnawed at her soul.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("No, she didn’t want to be alone, because then she’d have to come face-to-face with herself.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("From his spot on a high-backed chair across the long room, Mason watched Lily as she worked. She moved about her kitchen with grace and sensibility, never wasting a second or a step. She was efficient, tidy, and…she looked downright miserable.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Duty. Lily set such high store in duty. She was probably over there right now pondering their earlier decision to dismiss Daniel’s final wish. Lily would feel guilty and ashamed for not following through on Daniel’s misguided plans for her. Just as she felt guilty for never giving her husband a child.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Would she ever get over that? Would she be able to function here in the home she’d shared with Daniel, knowing that she had refused him his last, dying wish?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Steady, Mason,")]), _vm._v(" he told himself as he glanced over at the woman making war on the poor dinner salad ")]), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_vm._v("before her. He couldn’t go and get all noble now. Not after he’d told both her and himself that this whole idea was impossible. Besides, Lily would see right through any false nobility on his part. She’d always been able to see right through him.")])]), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And he’d always admired her from a distance, thinking he could never find a woman such as the one his older brother had been lucky enough to claim. Maybe that was why Mason never kept a relationship going for long. All the socialites in Dallas couldn’t hold a candle to Lily Winslow.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It suddenly hit him that he was being handed a delicate, precious gift. It also hit him that maybe, just maybe, his older brother had seen the chemistry between his wife and his brother—an innocent chemistry that spoke of a mutual affection and abiding respect—and had decided they’d be perfect for each other.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Or would they?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mutual affection aside, Mason still wasn’t ready to rush into anything. Nor, he suspected, was Lily. Besides, he surely didn’t want her to come to him out of a sense of duty.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("No, if Mason decided to follow through on his brother’s pointed suggestion, it would be on his own terms and in his own good time.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lily turned then, her gaze meeting his, her dark eyes wide with wonder. “Mason?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Hmm?” He shifted, glanced back at the papers he’d been absently clutching in one hand.")])]), _c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Are you all right? Is something wrong?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No, no,” he said as he stood up to stretch. “Just tired.” He waved a hand at the pocket calculator and the mound of papers. “This is going to take longer than I thought.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m sorry,” she said, rushing to the table. “You know, I can filter through this on my own. You don’t have to waste your time doing it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mason took her hand in his, his gaze gentle. “Lily, I don’t mind. I want to help. And I know you’re more than capable, because I’ve known for a very long time that you took care of things around here.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She became wary. “What makes you think that?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He shrugged. “Daniel was terrible with numbers, for one thing. And every time I’d come home, he’d brag about how organized and in order everything was. I bet you stayed up many a late night, going behind him, fixing things.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She had to smile. “I did. At first I just did it to help him out. He’d get so mad at himself, and he’d get mad at me for trying to fix things. So I had to learn to be sneaky, Lord forgive me. But you know, Daniel was so proud. And he thought it was the man’s responsibility to be the breadwinner.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And the mathematician?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_vm._v("“Yes. I didn’t want to undermine his authority, or embarrass him. I just didn’t want things to fall behind. After he got sick, I just naturally kept on ")]), _c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_vm._v("doing what had to be done. I don’t think he even cared at that point.”")])]), _c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But you cared.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes. I didn’t want us to lose this place.” She looked away then, out the window where crickets chirped in the nearby swamp. “I still don’t want to lose this place.” She waved a hand at the stack of papers on the table. “But I know it’s pretty bad.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mason nodded. He had to be honest with her. “I haven’t even begun to decipher it, but you’re right. It doesn’t look too promising.” Still holding her hand, he added, “Of course, you know I’ll be glad to buy you out and pay off everything.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No!” The one word tore at her even as she tore away from his touch. “I won’t let Daniel down. I promised him—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That you’d stay here, toiling away at this place, for his sake?” Anger clouded Mason’s next words. “Will you take over his bait-and-tackle shop and tour duties, too?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“If I have to. I’m certainly capable of showing people the best fishing spots on this lake.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_vm._v("He smiled in spite of his anger. “Oh, I don’t doubt that. You’d make it on sheer determination alone. But Lily, you’re already exhausted from nursing Daniel and trying to keep things up around here.” He shoved a hand at the table again. “And you’re already way behind. Even if you could make a go of the business, it’s a fickle and seasonal busi")]), _c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_vm._v("ness at best. You’ll be paying off debts for the rest of your life.”")])]), _c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Angry and embarrassed, she pushed the bills aside so she could set the table for their meal. “Well, what else do you suggest, Mason?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The words were out of his mouth before he even had time to think about them. “Well, how about exactly the same thing my brother suggested? Maybe we should get married, Lily. Maybe that is the best solution to all your problems, after all.”")])])]), _c('a', {
    attrs: {
      "id": "page36"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page36"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55dbef1d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781459203488_ch02.vue
// module id = 81
// module chunks = 0